
// Utils
import cn from '@/utils/cn';

// Styles
import styles from './PreTitle.module.css';

interface PreTitleProps {
  preTitle: string,
  color?: 'light' | 'dark',
  size?: 'p1' | 'p2' | 'p3',
}

function PreTitle({
  preTitle,
  color = 'dark',
  size = 'p1',

}: PreTitleProps) {
  
  return (
    <p className={cn([
      styles[`text-${color}`],
      styles[size],
    ])}>
      <span className={styles.prefix}>{'// '}</span>
      {preTitle}
    </p>
  );
}

export default PreTitle;